import React from 'react';
import { translate } from '@utils/i18n';
import { Button } from '@ui/atoms/Button';
const namespace = 'features.inspections_answer_by_type';
export function SelectionBar({ selCount, subEnabled, selectedNonSprinklerCount, selectedSprinklerCount, someSelSub, noneSelSub, onlyUnsupportedSelected, onBulkMarkSub, onClear }) {
    const isWarning = subEnabled && onlyUnsupportedSelected;
    return (React.createElement("div", { className: `qmb-selectionbar${isWarning ? ' is-warning' : ''}`, role: "status" },
        React.createElement("i", { className: `fa-solid ${isWarning ? 'fa-triangle-exclamation' : 'fa-circle-info'} qmb-selectionbar__icon`, "aria-hidden": "true" }),
        React.createElement("span", null,
            selCount === 1
                ? translate('selection_bar.item_selected', { namespace, count: selCount })
                : translate('selection_bar.items_selected', { namespace, count: selCount }),
            subEnabled && selectedNonSprinklerCount > 0 && selectedSprinklerCount > 0 && (React.createElement("span", { className: "qmb-selbar-note" },
                ' — ',
                selectedSprinklerCount === 1
                    ? translate('selection_bar.partial_update_note', {
                        namespace,
                        sprinkler_count: selectedSprinklerCount,
                        skipped_count: selectedNonSprinklerCount
                    })
                    : translate('selection_bar.partial_update_note_plural', {
                        namespace,
                        sprinkler_count: selectedSprinklerCount,
                        skipped_count: selectedNonSprinklerCount
                    }))),
            subEnabled && onlyUnsupportedSelected && (React.createElement("span", { className: "qmb-selbar-note" },
                ' — ',
                translate('selection_bar.sprinklers_only_note', { namespace })))),
        subEnabled && someSelSub && (React.createElement(Button, { variant: "primary", onClick: () => onBulkMarkSub(false) },
            React.createElement("i", { className: "fa-solid fa-rotate-left", "aria-hidden": "true" }),
            translate('selection_bar.restore_in_report', { namespace }))),
        subEnabled && noneSelSub && (React.createElement(Button, { variant: "primary", onClick: () => onBulkMarkSub(true) },
            React.createElement("i", { className: "fa-solid fa-user-helmet-safety", "aria-hidden": "true" }),
            translate('selection_bar.mark_as_sub', { namespace }))),
        subEnabled && onlyUnsupportedSelected && (React.createElement(Button, { variant: "primary", disabled: true },
            React.createElement("i", { className: "fa-solid fa-user-helmet-safety", "aria-hidden": "true" }),
            translate('selection_bar.mark_as_sub', { namespace }))),
        React.createElement("span", { className: "spacer", "aria-hidden": "true" }),
        React.createElement("span", { className: "sep", "aria-hidden": "true" }),
        React.createElement(Button, { onClick: onClear, "aria-label": translate('selection_bar.clear_aria', { namespace }) },
            React.createElement("i", { className: "fa-solid fa-xmark", "aria-hidden": "true" }))));
}
